<app-legal-layout
  eyebrow="Notice & Action · DSA Art. 16"
  title="Inhalt melden"
  lastUpdated="Mai 2026">

  @if (submitted(); as ack) {
    <section class="cr-melden__ok">
      <div class="cr-melden__ok-disc" aria-hidden="true">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
      </div>
      <h2>Danke — wir haben deine Meldung erhalten.</h2>
      <p>
        Unser Team prüft den Sachverhalt und meldet sich, sobald eine
        Entscheidung getroffen wurde. Üblicherweise innerhalb von 48 Stunden.
      </p>
      <dl class="cr-melden__ack">
        <div>
          <dt>Referenz</dt>
          <dd class="cr-mono">{{ ack.reportId }}</dd>
        </div>
        <div>
          <dt>Eingegangen</dt>
          <dd>{{ ack.createdAt | date: 'dd.MM.yyyy HH:mm' }}</dd>
        </div>
      </dl>
      <button type="button" class="cr-btn cr-btn--ghost" (click)="reset()">
        Weitere Meldung abgeben
      </button>
    </section>
  } @else {
    <p class="cr-melden__lead">
      Wenn dir auf Craftly Inhalte begegnen, die rechtswidrig sind oder gegen
      unsere AGB verstoßen, kannst du sie hier melden — auch ohne Login.
      Falsche Meldungen werten wir nicht: <strong>jede Meldung wird manuell geprüft</strong>,
      und wir begründen jede Entscheidung gegenüber den Beteiligten (Art. 17 DSA).
    </p>

    <form class="cr-melden__form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

      <div class="cr-melden__row">
        <label class="cr-melden__field">
          <span class="cr-melden__label">Welcher Inhalt?</span>
          <select formControlName="contentType" class="cr-melden__select">
            <option value="profile">Handwerker-Profil</option>
            <option value="review">Bewertung</option>
            <option value="anfrage">Anfrage</option>
            <option value="message">Nachricht</option>
            <option value="offer">Angebot</option>
          </select>
        </label>

        <label class="cr-melden__field">
          <span class="cr-melden__label">ID des Inhalts</span>
          <input
            type="text"
            formControlName="contentId"
            class="cr-melden__input cr-mono"
            placeholder="z. B. 5b8f2c40-…"
            autocomplete="off"
          />
          @if (form.controls.contentId.touched && form.controls.contentId.invalid) {
            <span class="cr-melden__error">Bitte die UUID des Inhalts eintragen (in der URL sichtbar).</span>
          }
        </label>
      </div>

      <label class="cr-melden__field">
        <span class="cr-melden__label">Art der Rechtsverletzung</span>
        <select formControlName="violationType" class="cr-melden__select">
          <option value="beleidigung">Beleidigung / Hassrede</option>
          <option value="falschinformation">Falschinformation / Verleumdung</option>
          <option value="urheberrecht">Urheberrechtsverletzung</option>
          <option value="spam">Spam / Werbung</option>
          <option value="betrug">Betrug</option>
          <option value="sonstiges">Sonstiges</option>
        </select>
      </label>

      <label class="cr-melden__field">
        <span class="cr-melden__label">Begründung (mindestens 20 Zeichen)</span>
        <textarea
          formControlName="description"
          rows="6"
          class="cr-melden__textarea"
          placeholder="Bitte beschreibe so konkret wie möglich, was an dem Inhalt rechtswidrig oder AGB-widrig ist."
          maxlength="4000"
        ></textarea>
        @if (form.controls.description.touched && form.controls.description.invalid) {
          <span class="cr-melden__error">Mindestens 20 Zeichen, maximal 4000.</span>
        }
      </label>

      <label class="cr-melden__field">
        <span class="cr-melden__label">
          Deine E-Mail (optional bei Login, Pflicht bei anonymer Meldung wenn du eine Antwort möchtest)
        </span>
        <input
          type="email"
          formControlName="reporterEmail"
          class="cr-melden__input"
          placeholder="meine.email@example.de"
          autocomplete="email"
        />
        @if (form.controls.reporterEmail.touched && form.controls.reporterEmail.invalid) {
          <span class="cr-melden__error">Bitte eine gültige E-Mail-Adresse eintragen.</span>
        }
      </label>

      @if (errorMessage()) {
        <div class="cr-melden__alert" role="alert">{{ errorMessage() }}</div>
      }

      <div class="cr-melden__actions">
        <a routerLink="/" class="cr-btn cr-btn--ghost">Abbrechen</a>
        <button
          type="submit"
          class="cr-btn cr-btn--primary"
          [disabled]="submitting()"
        >
          @if (submitting()) {
            Wird gesendet …
          } @else {
            Meldung abschicken
          }
        </button>
      </div>
    </form>

    <p class="cr-melden__legal">
      Hinweis: Vorsätzlich falsche Meldungen können Schadensersatzpflichten
      auslösen (§ 826 BGB). Wir geben Meldungen anonymisiert an betroffene
      Nutzer weiter, soweit zur Stellungnahme erforderlich.
    </p>
  }

</app-legal-layout>
